var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100"},[_c('b-embed',{staticClass:"w-100 h-100",attrs:{"aspect":_vm.options.aspect || '16by9',"src":_vm.src,"type":_vm.options.type || 'iframe',"allow-cross-origin":"","allowfullscreen":"","scrolling":"no"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }